export interface RolePermissions {
    canView: boolean;
    canEdit: boolean;
    canDelete: boolean;
    adminView: boolean;
    // Page access permissions
    pages: {
        dashboard: boolean;
        users: boolean;
        houses: boolean;
        photos: boolean;
        reservations: boolean;
        ical: boolean;
        reservationHistory: boolean;
        standardMessages: boolean;
        translations: boolean;
        feedbacks: boolean;
        blog: boolean;
        eSign: boolean;
        contactRequests: boolean;
        contacts: boolean;
    };
}

export const rolesConfig: Record<string, RolePermissions> = {
    "Admin": {
        canView: true,
        canEdit: false,
        canDelete: false,
        adminView: true,
        pages: {
            dashboard: true,
            users: true,
            houses: true,
            photos: true,
            reservations: true,
            ical: true,
            reservationHistory: true,
            standardMessages: true,
            translations: true,
            feedbacks: true,
            blog: true,
            eSign: true,
            contactRequests: true,
            contacts: true
        }
    },
    "Normal User": {
        canView: true,
        canEdit: true,
        canDelete: false,
        adminView: false,
        pages: {
            dashboard: true,
            users: false,
            houses: false,
            photos: true,
            reservations: true,
            ical: false,
            reservationHistory: false,
            standardMessages: false,
            translations: false,
            feedbacks: false,
            blog: false,
            eSign: false,
            contactRequests: false,
            contacts: true
        }
    },
    "Super Admin": {
        canView: true,
        canEdit: true,
        canDelete: true,
        adminView: true,
        pages: {
            dashboard: true,
            users: true,
            houses: true,
            photos: true,
            reservations: true,
            ical: true,
            reservationHistory: true,
            standardMessages: true,
            translations: true,
            feedbacks: true,
            blog: true,
            eSign: true,
            contactRequests: true,
            contacts: true
        }
    }
};

/**
 * Get permissions for a specific role
 * Returns default permissions if role not found
 */
export const getRolePermissions = (role: string): RolePermissions => {
    return rolesConfig[role] || {
        canView: false,
        canEdit: false,
        canDelete: false,
        adminView: false,
        pages: {
            dashboard: false,
            users: false,
            houses: false,
            photos: false,
            reservations: false,
            ical: false,
            reservationHistory: false,
            standardMessages: false,
            translations: false,
            feedbacks: false,
            blog: false,
            eSign: false,
            contactRequests: false,
            contacts: false
        }
    };
};

/**
 * Check if user has admin access
 */
export const isAdmin = (role: string): boolean => {
    const permissions = getRolePermissions(role);
    return permissions.adminView;
};

/**
 * Check if user can edit
 */
export const canEdit = (role: string): boolean => {
    const permissions = getRolePermissions(role);
    return permissions.canEdit;
};

/**
 * Check if user can view
 */
export const canView = (role: string): boolean => {
    const permissions = getRolePermissions(role);
    return permissions.canView;
};

/**
 * Check if user can delete
 */
export const canDelete = (role: string): boolean => {
    const permissions = getRolePermissions(role);
    return permissions.canDelete;
};